import { camelCase } from '../../utilities/string/index.js';

export function generateId(label, idPrefix) {
  return `${idPrefix}-${camelCase(label)}`;
}
